import { createContext } from 'react';
import type { ReportDataContextType } from '../types/report';

const ReportDataContext = createContext<ReportDataContextType>({
  reportData: null,
  summaryData: [],
  isSummaryLoading: false,
  currencyCode: '',
  reportConfigs: {
    isLoaded: false,
    isLoading: false,
    error: null
  },
  totalPages: 0,
  handlePageChange: () => {},
  pageLimit: {
    startIndex: 1,
    endIndex: 25
  },
  handleBackNavigation: () => {},
  reportTitle: 'Report',
  columnFilters: [],
  handleColumnFilterChange: () => {},
  columnFilterKeys: [],
  ftsFilterKeys: [],
  selectedColumnFilters: [],
  resetColumnFilters: () => {},
  removeColumnFilterValue: () => {},
  handleFtsFilterChange: () => {},
  selectedFtsFilters: [],
  removeFtsFilter: () => {},
  resetFtsFilters: () => {},
  freezeDateRangeDropdown: false,
  isReportExportEnabled: false,
  marketingHtmlUrl: null
});

export default ReportDataContext;
